import { createRoute } from '@tanstack/react-router';
import { msg } from 'gt-react';
import { ListChecksIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@/hooks/organization-config/useOrganizationEnabledModules';
import { waitForFeatureFlags } from 'src/integrations/feature-flags/feature-flags';
import {
  Route as pathlessAuthenticatedRoute,
  requireFeatureFlag,
  requireModules,
} from '../../route';
import { ARTasksPage } from './ARTasksPage';
import { ArTasksSearchSchema } from './arTasksSearch';

/**
 * AR Tasks: billing tasks (not invoiced; not sent). Needs the
 * AR module and the `ar-tasks-enabled` flag: otherwise the nav item is hidden
 * and a direct URL is not found.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-receivable/tasks',
  staticData: {
    app: {
      nav: {
        label: msg('Tasks', {
          context: 'sidebar nav label, Accounts Receivable section, AR tasks',
        }),
        icon: <ListChecksIcon className="h-4 w-4" weight="fill" />,
        group: 'Accounts Receivable',
        order: 16,
      },
      access: {
        featureFlag: 'ar-tasks-enabled',
        modulesAnyOf: [ProductModule.AR_INVOICING],
        // Task read alone: which tasks show follows the task queue's rule
        // (assignee, creator, watcher, queue-viewer group), so no AR access.
        permissionsAllOf: [{ action: Action.Read, subject: Subject.Task }],
      },
    },
  },
  component: ARTasksPage,
  loader: () => ({
    crumb: msg('Accounts Receivable Tasks', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    // On a cold load PostHog may not have returned flags yet; reading early
    // would treat the flag as off and show "not found" to an enabled user.
    await waitForFeatureFlags();
    requireFeatureFlag('ar-tasks-enabled');
    requireModules({ context, oneOf: [ProductModule.AR_INVOICING] });
  },
  validateSearch: ArTasksSearchSchema,
});
